<template>
  <v-layout align-center justify-center>
    <v-flex xs12 sm10 md8 lg6>
      <v-card class="elevation-12" align-center justify-center>
        <v-toolbar dark color="primary">
          <v-toolbar-title>RENO RODEO GOLF TOURNAMENT REGISTRATION</v-toolbar-title>
        </v-toolbar>
        <v-img
          src="/static/img/logo.png"
          height="150"
          contain
        ></v-img>

        <div class="headline text-xs-center mb-4">
          {{ currentYear }} RENO RODEO GOLF TOURNAMENT<br />
          <span class="title">
            Saturday, May 30, 2026<br />
            Lakeridge Golf Course, 1218 Golf Clud Dr. Reno, NV 89519<br />
            </span>
          <span class="subheading">
            Group Check-in: 7:00 am Shotgun: 8:00 am
          </span>
        </div>

        <div v-if="saved">
          <div class="subheading mx-4">
            <p>Your Registratoin has been entered. Rodeo tickets are available at <a href="https://www.renorodeo.com">www.renorodeo.com</a>.</p>
          </div>
        </div>
        <div v-else>
          <v-form
              ref="form"
              v-model="valid"
              lazy-validation
          >
          <v-card-text>
              <v-container grid-list-md>
                <v-layout wrap>
                  <v-flex class="title text-xs-center mt-4" xs12>
                    <span class="blue--text">PLAYER #1</span>
                  </v-flex>
                  <v-flex xs12 md6>
                    <v-text-field
                      prepend-icon="person"
                      v-model="editedItem.name"
                      label="Name"
                      :rules="[v => !!v || 'Name is required']"
                      required
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 md6>
                    <v-text-field
                    prepend-icon="email"
                    label="Email"
                    type="email"
                    v-model="editedItem.email"
                    :rules="emailRules"
                    required
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 md6>
                    <v-text-field
                      v-model="editedItem.phone"
                      label="Phone"
                      mask="(###) ###-####"
                      return-masked-value
                      prepend-icon="stay_current_portrait"
                      :rules="[v => !!v || 'Phone is required']"
                      required
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 md6>
                    <v-select
                      v-model="editedItem.shirtSize"
                      :items="sizes"
                      label="Shirt Size"
                      required
                    ></v-select>
                  </v-flex>
                  <v-flex xs12>
                    <v-text-field
                      v-model="editedItem.company"
                      label="Company Name"
                      ref="focusName"
                      :rules="[v => !!v || 'Company Name is required']"
                      required
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12>
                    <v-text-field
                      v-model="editedItem.address"
                      label="Address"
                      :rules="[v => !!v || 'Address is required']"
                      required
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12>
                    <v-layout wrap>
                      <v-flex xs10 md5>
                        <v-text-field
                          v-model="editedItem.city"
                          label="City"
                          :rules="[v => !!v || 'City is required']"
                          required
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs2 md2>
                        <v-text-field
                          v-model="editedItem.state"
                          label="ST"
                          mask="AA"
                          :rules="[v => !!v || 'State is required']"
                          required
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 md5>
                        <v-text-field
                          v-model="editedItem.zip"
                          label="Zipcode"
                          mask="#####"
                          :rules="[v => !!v || 'Zip is required']"
                          required
                        ></v-text-field>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <v-flex class="title text-xs-center mt-4" xs12>
                    <span class="blue--text">PLAYER #2</span>
                  </v-flex>
                  <v-flex xs12 md6>
                    <v-text-field
                      prepend-icon="person"
                      v-model="editedItem.name2"
                      label="Name"
                      :rules="[v => !!v || 'Name is required']"
                      required
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 md6>
                    <v-text-field
                      prepend-icon="email"
                      label="Email"
                      type="email"
                      v-model="editedItem.email2"
                      required
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12>
                    <v-text-field
                      v-model="editedItem.company2"
                      label="Company Name"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 md6>
                    <v-text-field
                      v-model="editedItem.phone2"
                      label="Phone"
                      mask="(###) ###-####"
                      return-masked-value
                      prepend-icon="stay_current_portrait"
                      required
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 md6>
                    <v-select
                      v-model="editedItem.shirtSize2"
                      :items="sizes"
                      label="Shirt Size"
                      required
                    ></v-select>
                  </v-flex>
                  <v-flex class="title text-xs-center mt-4" xs12>
                    <span class="blue--text">PLAYER #3</span>
                  </v-flex>
                  <v-flex xs12 md6>
                    <v-text-field
                      prepend-icon="person"
                      v-model="editedItem.name3"
                      label="Name"
                      :rules="[v => !!v || 'Name is required']"
                      required
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 md6>
                    <v-text-field
                      prepend-icon="email"
                      label="Email"
                      type="email"
                      v-model="editedItem.email3"
                      required
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12>
                    <v-text-field
                      v-model="editedItem.company3"
                      label="Company Name"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 md6>
                    <v-text-field
                      v-model="editedItem.phone3"
                      label="Phone"
                      mask="(###) ###-####"
                      return-masked-value
                      prepend-icon="stay_current_portrait"
                      required
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 md6>
                    <v-select
                      v-model="editedItem.shirtSize3"
                      :items="sizes"
                      label="Shirt Size"
                      required
                    ></v-select>
                  </v-flex>
                  <v-flex class="title text-xs-center mt-4" xs12>
                    <span class="blue--text">PLAYER #4</span>
                  </v-flex>
                  <v-flex xs12 md6>
                    <v-text-field
                      prepend-icon="person"
                      v-model="editedItem.name4"
                      label="Name"
                      :rules="[v => !!v || 'Name is required']"
                      required
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 md6>
                    <v-text-field
                      prepend-icon="email"
                      label="Email"
                      type="email"
                      v-model="editedItem.email4"
                      required
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12>
                    <v-text-field
                      v-model="editedItem.company4"
                      label="Company Name"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 md6>
                    <v-text-field
                      v-model="editedItem.phone4"
                      label="Phone"
                      mask="(###) ###-####"
                      return-masked-value
                      prepend-icon="stay_current_portrait"
                      required
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 md6>
                    <v-select
                      v-model="editedItem.shirtSize4"
                      :items="sizes"
                      label="Shirt Size"
                      required
                    ></v-select>
                  </v-flex>
                  <v-flex class="title text-xs-center mt-4" xs12>
                    <span class="blue--text">CREDIT CARD INFORMATION</span>
                  </v-flex>
                  <v-flex xs12 md6>
                    <v-container grid-list-md>
                      <v-layout wrap>
                        <v-flex xs12>
                          <span class="title">Includes greens fee, cart, beverages, food and more...</span>
                        </v-flex>
                        <v-flex xs12>
                          <v-radio-group v-model="editedItem.payType" @change="setPrice()">
                            <v-radio
                              label="$825 Foursome no Hole Sponsorship"
                              value="Foursome"
                            ></v-radio>
                            <v-radio
                              label="$1825 Foursome with Hole Sponsorship"
                              value="Foursome/Sponsor"
                            ></v-radio>
                            <v-radio
                              label="$1000 Hole Sponsorship"
                              value="Sponsor"
                            ></v-radio>
                          </v-radio-group>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-flex>
                  <v-flex xs12 md6>
                    <v-container grid-list-md>
                      <v-layout wrap>
                        <v-flex xs12>
                          <v-text-field
                            v-model="editedItem.number"
                            label="Credit Card Number"
                            :rules="[v => !!v || 'Credit Card Number is required']"
                            required
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs12>
                          <v-text-field
                            v-model="editedItem.cardName"
                            label="Name on Card"
                            :rules="[v => !!v || 'Name on Card is required']"
                            required
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs6 md3>
                          <v-text-field
                            v-model="editedItem.expire"
                            label="Expires"
                            mask="##/##"
                            return-masked-value
                            :rules="[v => !!v || 'Expires is required']"
                            required
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs12 md3 offset-md1>
                          <v-text-field
                            v-model="editedItem.cvv"
                            label="CVV"
                            mask="####"
                            :rules="[v => !!v || 'CVV is required']"
                            required
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs12 md3 offset-md1>
                          <v-text-field
                            v-model="editedItem.amount"
                            label="Amount"
                            :rules="[v => !!v || 'Amount is required']"
                            mask="####"
                            prefix="$"
                            readonly
                            required
                          ></v-text-field>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-flex>
                  <v-flex class="title text-xs-center mt-4" xs12>
                    Breakfast and Lunch will be served
                  </v-flex>
                </v-layout>
              </v-container>
            <v-alert :value="error" type="warning" transition="scale-transition">
              <span v-html="error"></span>
            </v-alert>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" @click="save">Submit</v-btn>
          </v-card-actions>
        </v-form>
        </div>
      </v-card>
    </v-flex>

    <v-snackbar
      v-model="snackbar.show"
      :color="snackbar.color"
      :multi-line=true
      :timeout="6000"
    >
      {{ snackbar.message }}
      <v-btn
        dark
        flat
        @click="snackbar.show = false"
      >
        Close
      </v-btn>
    </v-snackbar>
  </v-layout>
</template>

<script>
import Api from '@/services/Api'
import moment from 'moment'

export default {
  data () {
    return {
      valid: true,
      currentYear: 0,
      saved: false,
      checkbox: false,
      dates: [],
      sizes: [ 'S', 'M', 'L', 'XL', 'XXL', 'XXXL' ],
      groups: [ 'Morning', 'Afternoon' ],
      editedItem: {
        amount: 825,
        payType: 'Foursome'
      },
      emailRules: [
        v => !!v || 'E-mail is required',
        v => /.+@.+/.test(v) || 'E-mail must be valid'
      ],
      error: null,
      finalsDate: '',
      snackbar: {
        show: false,
        color: '',
        message: ''
      }
    }
  },

  created () {
    this.getDate()
  },

  methods: {
    getDate () {
      let currentYear = moment().format('YYYY')
      let nextYear = moment()
        .add(1, 'years')
        .format('YYYY')
      let currentDate = moment().format('MM')

      if (currentDate >= 7) {
        this.currentYear = nextYear
      } else {
        this.currentYear = currentYear
      }
    },

    setPrice () {
      console.log(this.editedItem.payType)
      if (this.editedItem.payType === 'Foursome/Sponsor') {
        this.editedItem.amount = 1825
      } else if (this.editedItem.payType === 'Sponsor') {
        this.editedItem.amount = 1000
      } else {
        this.editedItem.amount = 825
      }
    },

    async save () {
      try {
        this.editedItem.year = this.currentYear

        if (this.$refs.form.validate()) {
          const response = await Api().post('extern_golf', this.editedItem)
          this.editedItem = {}
          this.editedItem.amount = 825
          this.editedItem.payType = 'Foursome'

          this.saved = true
          this.snackbar.message = response.data.message + ' Congratulation, your entry has been submitted!'
          this.snackbar.color = 'success'
          this.snackbar.show = true
        } else {
          this.snackbar.message = 'You have some errors on the page!'
          this.snackbar.color = 'error'
          this.snackbar.show = true
        }
      } catch (error) {
        this.snackbar.message = error.response.data.error
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/golf/ExternalForm.vue